import { Component, OnInit, NgZone } from '@angular/core';
import { IonicModule, ModalController, Platform } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components';
import { TourPage, PremiumPage } from '..';
import { Router } from '@angular/router';
import {
  CapacitorService,
  FirebaseService,
  FriendsService,
  EventsService,
  IonicService,
  HttpService,
} from 'src/app/services';

@Component({
  standalone: true,
  selector: 'page-invite',
  templateUrl: './invite.page.html',
  styleUrls: ['./invite.page.scss'],
  imports: [
    IonicModule, CommonModule, FormsModule,
    ReactiveFormsModule, ComponentsModule
  ],
})
export class InvitePage implements OnInit {

  data: any;
  view: any;
  id!: string;
  type!: string;
  invites: any;
  spinner: boolean = false;

  //----------------------------------------------------------------------------
  // Constructor
  //----------------------------------------------------------------------------

  constructor(
    public modalInvite: ModalController,
    public capacitor: CapacitorService,
    public firebase: FirebaseService,
    public friends: FriendsService,
    public events: EventsService,
    public ionic: IonicService,
    public platform: Platform,
    public http: HttpService,
    public router: Router,
    public zone: NgZone
  ) { }

  //----------------------------------------------------------------------------
  // Initialize
  //----------------------------------------------------------------------------

  ngOnInit() {
    this.firebase.setScreen('Invite');
    this.events.subscribeEvent('invite', () => { this.getData(); });
    this.getData();
  }

  ngOnDestroy() {
    this.events.destroyEvent('invite');
  }

  //----------------------------------------------------------------------------
  // Get Data
  //----------------------------------------------------------------------------

  async getData() {
    this.zone.run(async () => {
      if (this.id) {
        this.data = await this.http.getRequest('/view/' + this.id);
        this.invites = this.data?.invites;
        this.view = this.data?.view;
      }
      if (!this.id) {
        this.data = await this.http.getRequest('/me/invites');
        this.invites = this.data;
      }
    });
  }

  //----------------------------------------------------------------------------
  // Open Tour
  //----------------------------------------------------------------------------

  async openTour() {
    this.firebase.setEvent('invite_tour');
    this.ionic.openPage(TourPage, 'invites');
  }

  //----------------------------------------------------------------------------
  // Open Premium
  //----------------------------------------------------------------------------

  async openPremium() {
    this.firebase.setEvent('invite_premium');
    this.ionic.openPage(PremiumPage, 'premium');
  }

  //----------------------------------------------------------------------------
  // Close View
  //----------------------------------------------------------------------------

  async closePage() {
    const modal = await this.modalInvite.getTop();
    if (modal) {
      modal.setCurrentBreakpoint(0);
    } else {
      await this.modalInvite.dismiss();
    }
    this.events.refreshPages();
  }
}
